const initialState = {
  user: null,
  isAuthenticated: false,
  error: null
};

function authentication(state = initialState, action) {
  switch (action.type) {
    case "USER_DATA":
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        error: null
      };
    case "LOGIN_SUCCESS":
      return {
        ...state,
        isAuthenticated: true,
        error: null
      };
    case "LOGIN_ERROR":
      return {
        ...initialState,
        error: action.message || true
      };
    case "LOGOUT":
    case "LOGIN_LOGOUT":
      return {
        ...initialState,
        error: action.error || null
      };
    default:
      return state;
  }
}

export default authentication;



// WEBPACK FOOTER //
// ./reducers/authentication.js